import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PageLayoutComponent } from '@spartacus/storefront';
import { ReviewOrdersPage } from './pages/review-orders-page/review-orders-page.component';
import { SSOLoginGuard } from './core/guards/sso-login.guard';
import { reviewOrderExitGuard } from './core/guards/review-order-exit.guard';

export const customRoutes: Routes = [
  {
    path: 'sso/login',
    component: PageLayoutComponent,
    canActivate: [SSOLoginGuard],    
  },
  {
    path: 'review-order/:cartId',
    component: ReviewOrdersPage,
    canDeactivate: [reviewOrderExitGuard],
    data: { pageLabel: 'reviewOrder' },
  },
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot([], {
      anchorScrolling: 'enabled',
      initialNavigation: 'enabledBlocking',
      scrollPositionRestoration: 'top',
      onSameUrlNavigation: 'reload',
    }),
    RouterModule.forChild(customRoutes),
  ],
  exports: [RouterModule],
})

export class AppRoutingModule {}